<div class="flex flex-col">
  <div>
    <span>{{ 'act.authentication-setup-page.description' | translate }}</span>
  </div>
  <div class="mb-6 mt-4">
    <a
      href="{{ 'authentication-setup-page.need-help.url' | translate }}"
      target="_blank"
      class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130">
      {{ 'authentication-setup-page.need-help' | translate }}
    </a>
  </div>
  @if (mfaToken(); as mfa) {
    <pay-login-setup-two-factor-auth-chooser [mfaBearer]="mfa" />
  }
</div>
